/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useMemo, useState } from "react";

import "./Finance.scss";
import classnames from "classnames";
import {
  Badge,
  Card,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
} from "reactstrap";
import OrderIcon from "../../assets/images/orderProduct.png";
import VectorDown from "../../assets/images/Vector-Down.png";
import Warning from "../../assets/images/warning-2.png";
import searchIcon from "../../assets/images/search-normal.png";
import location from "../../assets/images/LOCATION.png";
import cellTab from "../../assets/images/phoneNumber.png";
import UserIcon from "../../assets/images/TASB.png";
import Mobile from "../../assets/images/MOBILESCCS.png";

// RangeSlider
import "nouislider/distribute/nouislider.css";

import deletIcon from "../../../assets/images/deleteIcon.svg";
import editIcon from "../../../assets/images/editIcon.svg";
import ViewIcon from "../../../assets/images/viewicon.svg";
//redux
import PaginatedTable from "Components/Common/PaginatedTable";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { createSelector } from "reselect";
import { getAuthMe, updateProductToggle } from "slices/thunks";
import { Constant } from "utils/enums";
import { getProducts, postRefreshAuth } from "helpers/backend_helper";
import BreadCrumb from "Components/Common/BreadCrumb";
import Icomeover from "./Components/Icomeover";
import Statement from "./Components/statement";
import DetailStatement from "./Components/DetailStatement";
import vecTor from "../../assets/images/Vector.png";
import BillingAddresModal from "./Components/BillingAddresModal";
import BreadCrumbforback from "Components/Common/BreadCrumbForBack";
import { getOrderDetailIncomeThunk } from "live-slices/OrderStatements/thunks";
import ErrorModal from "Components/Common/ErrorModal";

const Detailorder = (props: any) => {
  document.title = "Income Order Detail | BuyPass";
  const dispatch: any = useDispatch();

  const [activeBar, setActiveBar] = useState<any>("incomeOverview");
  const [billingAddresModal, setBillingAddresModal] = useState(false);
  const [orderDetail, setorderDetail] = useState<any>({});
  const [showModal, setShowModal] = useState({
      isVisible: false,
      color: false,
    });
  const [errorMessage, setErrorMessage] = useState<string>("");
    

  const selectedStatementOrderData = createSelector(
    (state: any) => state.OverViewStatement,
    (incomeOrderDetail) => incomeOrderDetail?.incomeOrderDetail
  );
  const orderDetailIncome = useSelector(selectedStatementOrderData);

  const params = useParams();

  const locationn = useLocation();
  const orderId =
    locationn.state?.orderId ||
    params.id ||
    new URLSearchParams(locationn.search).get("orderId");


  useEffect(() => {
    dispatch(getOrderDetailIncomeThunk(orderId));
    setorderDetail(orderDetailIncome);

    console.log(orderDetailIncome)
  }, [orderDetail]);

  return (
    <>
      <BillingAddresModal
        show={billingAddresModal}
        onCloseClick={() => setBillingAddresModal(false)}
      />
      <ErrorModal
              show={showModal.isVisible}
              message={errorMessage}
              color={showModal.color}
              onCloseClick={() => setShowModal({ isVisible: false, color: false })}
            />
      <div className="page-content page-content-mobile">
        <ToastContainer closeButton={false} limit={1} />

        <Container fluid>
          <BreadCrumbforback
            title="Detail Products"
            pageTitle="My Income"
            pageTitleRoute="/my-income"
          />
        </Container>

        <div className="Section-One">
          <Row>
            <Col xl={9} lg={9} md={9} sm={12}>
              <Card className="CARD">
                <div>
                  <h6 className="inforMation">Buyer Information</h6>

                  <div className="Buyer">
                    <div className="COD">
                      <h5>Customer Name</h5>
                      <div className="Customer">
                        <img src={UserIcon} alt="" />
                        <h6>{orderDetailIncome?.userDetails?.name || "-"}</h6>
                        <img src={cellTab} alt="" />
                      </div>
                      <p>Payment Method</p>
                      <button>COD</button>
                    </div>
                    <div className="COD">
                      <h5>Customer ID</h5>
                      <div className="Customer">
                        {/* <img src={UserIcon} alt="" /> */}
                        <h4>{orderDetailIncome?.userDetails?._id || "-"}</h4>
                        {/* <img src={cellTab} alt="" /> */}
                      </div>
                      <p>Email</p>
                      <button className="Data">{orderDetailIncome?.userDetails?.email || "-"}</button>
                    </div>
                    <div className="COD">
                      <h5>Customer Phone</h5>
                      <div className="Customer">
                        {/* <img src={UserIcon} alt="" /> */}
                        <h4>{orderDetailIncome?.userDetails?.phoneNumber || "-"}</h4>
                        {/* <img src={cellTab} alt="" /> */}
                      </div>
                      <p>Tax Code</p>
                      <button className="Data">No Data</button>
                    </div>
                    <div className="success">
                      <div className="borDer">
                        <h5>{(orderDetailIncome?.successfulDeliveryRate || 0).toFixed(1)}%</h5>
                      </div>
                      <h4>
                        Successful <br /> Delivery Rate
                      </h4>
                    </div>
                    <div className="success">
                      <div className="borDer">
                        <h5>{(orderDetailIncome?.successfulDeliveryCount || 0).toFixed(1)}%</h5>
                      </div>
                      <h4>
                        Successful <br /> Delivery Count
                      </h4>
                    </div>
                  </div>
                </div>
              </Card>
              <Card className="CARD">
                <div className="packageS">
                  <h6>Order Number:</h6>
                  <div>
                    <p>
                      {orderDetailIncome?.orderId || "-"}
                     <span>
                          <i
                            className="bx bx-copy text-secondary fs-6 fw-light cursor-pointer copy-icon ms-1"
                            data-testing-id="copyColor_order"
                            onClick={(event) => {
                              event.stopPropagation();
                              navigator.clipboard.writeText(orderDetailIncome?.orderId);
                              setShowModal({ isVisible: true, color: true });
                              setErrorMessage("Order Number Copied!.");
                              setTimeout(() => {
                                setShowModal({
                                  isVisible: false,
                                  color: true,
                                });
                              }, 1000);
                            }}
                          ></i>
                        </span>
                    </p>
                  </div>
                  <div>
                    <p className="Create">
                      Create Time: <span>{orderDetailIncome?.createdOn ? new Date(orderDetailIncome.createdOn).toLocaleDateString() : "-"}</span>
                    </p>
                  </div>
                </div>
                <div>
                  <div className="Delivered">
                    <h5>{orderDetailIncome?.status || "-"} </h5>
                    <p className="Package">
                      Package <span>1</span>
                    </p>
                    <p className="item">{orderDetailIncome?.items?.length} items</p>
                  </div>
                </div>
                <div className="Table-mian">
                  <div className="GirthWidth">
                    <div className="girth-One">
                      <input type="checkbox" data-testing-id="iTemDetail" />

                      <h6>Item</h6>
                    </div>
                    <div className="girth-Two">
                      <h6>Retail Price</h6>
                    </div>
                    <div className="girth-Three">
                      <h6>Paid Amount</h6>
                    </div>
                    <div className="girth-Four">
                      <h6>Delivery Type</h6>
                    </div>
                    <div className="girth-Five">
                      <h6>Warehouse </h6>
                    </div>
                    <div className="girth-Six">
                      <h6>Status</h6>
                    </div>
                  </div>
                  {orderDetailIncome?.items?.[0] && (
                    <>
                      <div className="GirthWidtH">
                        <div className="girth-One">
                          <input
                            type="checkbox"
                            data-testing-id={"WirelessPRo" + props.index}
                          />

                          <div className="boX">
                            <img src={orderDetailIncome.items[0].productImage} alt="" />
                            <div>
                              <p>{orderDetailIncome.items[0].productName}</p>
                              <p className="seller">
                                Seller SKU: {orderDetailIncome.items[0].sku}
                              </p>
                              <p className="seller">Warehouse: Local Stock</p>
                              <p className="seller">
                                Expected Delivery: 15 May 2025 - 15 May 2025
                              </p>
                              <p className="seller">
                                Order Line ID: {orderDetailIncome.items[0].statementId}
                              </p>
                              <p className="seller">Item ID: {orderDetailIncome.items[0]._id}</p>
                            </div>
                          </div>
                        </div>

                        <div className="girth-Two">
                          <h6>Rs. {(orderDetailIncome.items[0].overallItemSummary.productPrice - orderDetailIncome.items[0].overallItemSummary.adjustmentPrice - orderDetailIncome.items[0].overallItemSummary.buypassProfit) || 0}</h6>
                        </div>

                        <div className="girth-Three">
                          <h6>
                            Rs.{" "}
                            <span>
                             {(orderDetailIncome.items[0].overallItemSummary.productPrice - orderDetailIncome.items[0].overallItemSummary.adjustmentPrice - orderDetailIncome.items[0].overallItemSummary.buypassProfit) || 0}
                            </span>
                          </h6>
                        </div>

                        <div className="girth-Four">
                          <h6>
                            {orderDetailIncome.items[0]?.orderType || "-"}
                          </h6>
                        </div>

                        <div className="girth-Five">
                          <h6>Dropshipping</h6>
                        </div>

                        <div className="girth-SiX">
                          <div className="newOrder">
                            <div className="dot"></div>
                            <p style={{ textTransform: "capitalize" }}>Delivered</p>
                          </div>
                        </div>
                      </div>

                      <div className="conTent">
                        <div className="Promotions">
                          <h6>Promotions</h6>
                          <div>
                            <p>
                              No. 1 ID: <span>{orderDetailIncome.items[0].statementId}</span>
                            </p>
                          </div>
                          <div>
                            <p>
                              Provider: <span> SponserType-Seller</span>
                            </p>
                          </div>
                          <div>
                            <p>
                              Discount: <span> Rs 0.00</span>
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="Expend">
                        <h5>Expend</h5>
                        <img src={VectorDown} alt="" />
                      </div>

                      <div className="borDER"></div>

                      <div className="trackNumber">
                        <p>
                          Tracking Number: <span>{orderDetailIncome.items[0].statementNumber}</span>
                        </p>
                        <div className="select-And-Inputs">
                          <select data-testing-id="statusSelect_PromotionListing">
                            <option value="">More Action</option>
                            <option value="true">Active</option>
                            <option value="false">Inactive</option>
                          </select>
                          <div>
                            <button>Logistic Status</button>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                </div>
                {/* <div className="conTent">
                  <div className="Promotions">
                    <h6>Promotions</h6>
                    <div>
                      <p>
                        No. 1 ID: <span>456456456456456</span>
                      </p>
                    </div>
                    <div>
                      <p>
                        Provider: <span> SponserType-Seller</span>
                      </p>
                    </div>
                    <div>
                      <p>
                        {" "}
                        Discount: <span> Rs 0.00</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="conTent">
                  <div className="Promotions">
                    <h1>Promotions</h1>
                    <div>
                      <p>
                        No. 1 ID: <span>456456456456456</span>
                      </p>
                    </div>
                    <div>
                      <p>
                        Provider: <span> SponserType-Seller</span>
                      </p>
                    </div>
                    <div>
                      <p>
                        {" "}
                        Discount: <span> Rs 0.00</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="Expend">
                  <h5>Expend</h5>
                  <img src={VectorDown} alt="" />
                </div>
                <div className="borDER"></div>
                <div className="trackNumber">
                  <p>
                    Tracking Number: <span>PK-34759347598346</span>
                  </p>
                  <div className="select-And-Inputs">
                    <select
                      // value={status}
                      data-testing-id="statusSelect_PromotionListing"
                    >
                      <option
                        value=""
                        data-testing-id="selectStatusOption_PromotionListing"
                      >
                        More Action
                      </option>
                      <option
                        value="true"
                        data-testing-id="activeOption_PromotionListing"
                      >
                        Active
                      </option>
                      <option
                        value="false"
                        data-testing-id="inactiveOption_PromotionListing"
                      >
                        Inactive
                      </option>
                    </select>
                    <div>
                      <button>Logistic Status</button>
                    </div>
                  </div>
                </div> */}
              </Card>
                  {orderDetailIncome.items?.length > 0 ? (
  orderDetailIncome.items.map((item: any, index: number) => (
              <Card className="CARD">
                <div className="Payment financeMainDv">
                  <h6>My Payment Information</h6>
                  <h5>Details</h5>
                  <div className="Table-mian">
                    <div className="GirthWidth">
                      <div className="girth-One">
                        {/* <input type="checkbox" /> */}

                        <h6>Item</h6>
                        {/* <input type="checkbox" />

                    <div className="boX">
                      <img src={OrderIcon} alt="" />
                      <div>
                        <p>Portable Toothbrush amp...</p>
                        <p className="potable">
                          Order Number: TS148....495345{" "}
                          <span>
                            <img src={Mobile} alt="" />
                          </span>
                        </p>
                        <p className="potable">
                          Order Line ID: TS148....495345:{" "}
                          <span>
                            <img src={Mobile} alt="" />
                          </span>
                        </p>
                      </div>
                    </div> */}
                      </div>
                      <div className="girth-Two">
                        <h6>Retail Price</h6>
                      </div>
                      <div className="girth-Three">
                        <h6>Paid Amount</h6>
                      </div>
                      <div className="girth-Four">
                        <h6>Delivery Type</h6>
                      </div>
                    </div>
     
    <div key={index}>
           <div className="GirthWidtH">
                      <div className="girth-One">
                        <input type="checkbox" />

                        <div className="boX">
                          <img src={item.productImage} alt="" />
                          <div>
                            <p>{item.productName}</p>
                            <p className="seller">Seller SKU: {item.sku || '-'}</p>
                            <p className="seller">Warehouse: Local Stock</p>
                            <p className="seller">
                              Expected Delivery: 15 May 2025 - 15 May 2025
                            </p>
                            <p className="seller">
                              Order Line ID: {item?._id || '-'}
                            </p>
                            <p className="seller">Item ID: {item._id || '-'}</p>
                          </div>
                        </div>
                      </div>
                      <div className="girth-Two">
                        <h6>Rs. {(item.overallItemSummary.productPrice - item.overallItemSummary.adjustmentPrice - item.overallItemSummary.buypassProfit) || 0}</h6>
                      </div>
                      <div className="girth-Three">
                        <h6>
                          Rs. <span>{(item.overallItemSummary.productPrice - item.overallItemSummary.adjustmentPrice - item.overallItemSummary.buypassProfit) || 0}</span>
                        </h6>
                      </div>
                      <div className="girth-Four">
                        <h6>
                          <span>{item.orderType || '-'}</span>
                        </h6>{" "}
                      </div>
                    </div>
    </div>

                  </div>
                  <div>
                    <div className="Main-check">
                      <div className="GirthWidtH">
                        <div className="girth-One">
                          <h6>Summary</h6>
                        </div>
                        <div className="girth-Two">
                          <h6>Commission Fee</h6>
                        </div>
                        <div className="girth-Three">
                          <h6>
                            Rs. <span>{item.overallItemSummary.commission || '0'}</span>
                          </h6>
                        </div>
                      </div>
                      {/* <div className="GirthWidtH">
                        <div className="girth-One">
                        </div>
                        <div className="girth-Two">
                          <h6>Discount</h6>
                        </div>
                        <div className="girth-Three">
                          <h6>
                            Rs. <span>{item.overallItemSummary.commission || '0'}</span>
                          </h6>
                        </div>
                      </div> */}
                  
                      <div className="GirthWidtH">
                        <div className="girth-One">
                          {/* <h6>Summary</h6> */}
                        </div>
                        <div className="girth-Two">
                          <h6>Package Handling Fee</h6>
                        </div>
                        <div className="girth-Three">
                          <h6>
                            Rs. <span>{item.overallItemSummary.packageHandling || '0'}</span>
                          </h6>
                        </div>
                      </div>
                      <div className="GirthWidtH">
                        <div className="girth-One">
                          {/* <h6>Summary</h6> */}
                        </div>
                        <div className="girth-Two">
                          <h6>Cash Handling Fee</h6>
                        </div>
                        <div className="girth-Three">
                          <h6>
                            Rs. <span>{item.overallItemSummary.cashHandlingFee || '0'}</span>
                          </h6>
                        </div>
                      </div>
                      {/* <div className="GirthWidtH">
                        <div className="girth-One">
                        </div>
                        <div className="girth-Two">
                          <h6>Shipping Fee</h6>
                        </div>
                        <div className="girth-Three">
                          <h6>
                            Rs. <span>{orderDetailIncome?.orderSummary?.shippingfee || '0'}</span>
                          </h6>
                        </div>
                      </div> */}
                   
                      <div className="GirthWidtH">
                        <div className="girth-One">
                          {/* <h6>Summary</h6> */}
                        </div>
                        <div className="girth-Two">
                          <h6 className="Product-Price">Grand Total</h6>
                        </div>
                        <div className="girth-Three">
                          <h6 className="Product-Price">
                            Rs. <span>{(item.overallItemSummary.productPrice - item.overallItemSummary.adjustmentPrice - item.overallItemSummary.buypassProfit) || '0'}</span>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Card>
                ))
) : (
  <p>No items found.</p>
)}
  
              <Card>
                <div className="Max-fees financeMainDv">
                   <div className="Main-check">
                      <div className="GirthWidtH">
                        <div className="girth-One">
                          <h6>Summary</h6>
                        </div>
                        <div className="girth-Two">
                          <h6>Commission Fee</h6>
                        </div>
                        <div className="girth-Three">
                          <h6>
                            Rs. <span>{orderDetailIncome?.orderSummary?.commission || '0'}</span>
                          </h6>
                        </div>
                      </div>
                      <div className="GirthWidtH">
                        <div className="girth-One">
                          {/* <h6>Summary</h6> */}
                        </div>
                        <div className="girth-Two">
                          <h6>Discount</h6>
                        </div>
                        <div className="girth-Three">
                          <h6>
                            Rs. <span>{orderDetailIncome?.orderSummary?.discount || '0'}</span>
                          </h6>
                        </div>
                      </div>
                  
                      <div className="GirthWidtH">
                        <div className="girth-One">
                          {/* <h6>Summary</h6> */}
                        </div>
                        <div className="girth-Two">
                          <h6>Package Handling Fee</h6>
                        </div>
                        <div className="girth-Three">
                          <h6>
                            Rs. <span>{orderDetailIncome?.orderSummary?.packageHandling || '0'}</span>
                          </h6>
                        </div>
                      </div>
                      <div className="GirthWidtH">
                        <div className="girth-One">
                          {/* <h6>Summary</h6> */}
                        </div>
                        <div className="girth-Two">
                          <h6>Cash Handling Fee</h6>
                        </div>
                        <div className="girth-Three">
                          <h6>
                            Rs. <span>{orderDetailIncome?.orderSummary?.cashHandlingFee || '0'}</span>
                          </h6>
                        </div>
                      </div>
                      {/* <div className="GirthWidtH">
                        <div className="girth-One">
                        </div>
                        <div className="girth-Two">
                          <h6>Shipping Fee</h6>
                        </div>
                        <div className="girth-Three">
                          <h6>
                            Rs. <span>{orderDetailIncome?.orderSummary?.shippingfee || '0'}</span>
                          </h6>
                        </div>
                      </div> */}
                   
                      <div className="GirthWidtH">
                        <div className="girth-One">
                          {/* <h6>Summary</h6> */}
                        </div>
                        <div className="girth-Two">
                          <h6 className="Product-Price">Grand Total</h6>
                        </div>
                        <div className="girth-Three">
                          <h6 className="Product-Price">
                            Rs. <span>{orderDetailIncome?.orderSummary?.sellerPrice || '0'}</span>
                          </h6>
                        </div>
                      </div>
                    </div>
                  <div className="Expend">
                    <h5>Expend</h5>
                    <img src={VectorDown} alt="" />
                  </div>
                </div>
              </Card>
            </Col>

            <Col xl={3} lg={3} md={3} sm={12}>
              <Card className="">
                <div className="Seller">
                  <div className="head">
                    <h3>Order Note</h3>
                  </div>
                  <div className="border"></div>
                  <div className="note">
                    <p>Seller Note</p>
                    <h5>Edit</h5>
                  </div>
                </div>
              </Card>

              <Card>
                <div className="buyer">
                  <div className="address">
                    <img src={location} alt="" />
                    <h5>Buyer Address</h5>
                  </div>
                  <div className="border"></div>
                  <div className="INFO">
                    <p>Show Personal Info</p>
                    <div className="ship">
                      <p>Shipping Address</p>
                      <button>{orderDetailIncome?.address?.addressType || '-'}</button>
                    </div>
                  </div>
                  <div className="Mation">
                    <p>{orderDetailIncome?.address?.streetAddress || '-'}</p>
                    <p>{orderDetailIncome?.address?.city || '-'}</p>
                    <p>{orderDetailIncome?.address?.state || '-'}</p>
                    <p>
                      Phone No <span>{orderDetailIncome?.address?.phoneNumber || '-'}</span>
                    </p>
                  </div>
                  <div className="BillinG">
                    <p onClick={() => setBillingAddresModal(true)}>
                      Show Billing Address
                    </p>
                  </div>
                </div>
              </Card>
              <Card>
                <div className="history">
                  <div className="Order">
                    <h6>Order History</h6>
                    <p>Package </p>
                  </div>
                  <div className="View">
                    <p>View Item History</p>
                    <img src={vecTor} alt="" />
                  </div>
                  {orderDetailIncome?.activities?.map((activity: any, index: number) => (
                    <div className="live-chat" key={index}>
                      <div className="feb">
                        <h5>{activity?.createdOn
                          ? new Date(activity.createdOn).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                          })
                          : '-'}</h5>
                        <p>{activity?.updateTime
                          ? new Date(activity.updateTime).toLocaleTimeString('en-US', {
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: true,
                          })
                          : '0'}</p>
                      </div>
                      <div>
                        <div className="Del-border"></div>
                        <div className="Del-Border"></div>
                      </div>

                      <div className="St">
                        <h5>{activity?.type}</h5>
                        <p>{activity?.sellerDescription} </p>
                        {/* <h4>Pakistan Lahore - Pak Arab Society</h4> */}
                      </div>
                    </div>
                  ))}
                  {/* <div className="live-Chat">
                    <div className="feb">
                      <h5>Feb.01</h5>
                      <p>10:30</p>
                    </div>
                    <div>
                      <div className="Del-border"></div>
                      <div className="Del-Border"></div>
                    </div>

                    <div className="St">
                      <h5>Delivered</h5>
                      <p>123 Main St, Karachi, </p>
                      <h4>Pakistan Lahore - Pak Arab Society</h4>
                    </div>
                  </div>
                  <div className="live-Chat">
                    <div className="feb">
                      <h5>Feb.01</h5>
                      <p>10:30</p>
                    </div>
                    <div>
                      <div className="Del-border"></div>
                      <div className="Del-Border"></div>
                    </div>

                    <div className="St">
                      <h5>Delivered</h5>
                      <p>123 Main St, Karachi, </p>
                      <h4>Pakistan Lahore - Pak Arab Society</h4>
                    </div>
                  </div> */}
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default Detailorder;
